module.exports = __webpack_public_path__ + "img/Group 5.54937c0d.svg";